import React, { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getInventoryLocations } from '../../actions/inventory';
import { InventoryLocationType } from '../../pages/Inventory/InventoryController';
import Select from '../../common/Form/Select';
import { debounce } from '../../utils/common';
import { useFormContext } from 'react-hook-form';
import { CLEAR_INVENTORY_LOCATIONS_DROPDOWN_LIST_DATA } from '../../types/inventory';

export default function RepairCenter({ name, label, onChange = () => { }, org_id, prefill = [], addNew = false, className = '', readOnly = false, org_check_required = true, required = false, prefillObj = null }) {
    const dispatch = useDispatch();
    const methods = useFormContext();
    const repairCenterDropdown = useSelector((state) => state.inventory.repairCenterDropdown);
    const isRepairCenterDropdownLoading = useSelector((state) => state.loading.isRepairCenterDropdownLoading);

    const memoizedRepairCenterDropdown = useMemo(() => {
        const warehouseOptions = repairCenterDropdown || [];
        return addNew ? [{ label: 'Add New Warehouse', value: 'add-new-warehouse' }, ...warehouseOptions] : warehouseOptions;
    }, [repairCenterDropdown, addNew]);

    const getWarehouseList = useCallback(({ limit = 100, page = 1, query = '', org_id }) => {
        dispatch(getInventoryLocations({ limit, page, query, dropdown: true, type: InventoryLocationType.WAREHOUSE, payload: { org_id }, is_repair_center: true }));
    }, [dispatch]);

    const debouncedWarehouseSearchSearch = useMemo(() => debounce(getWarehouseList), [getWarehouseList]);

    useEffect(() => {
        let payload = {
            limit: 100,
            page: 1,
        };
        if (org_check_required) payload.org_id = org_id;
        getWarehouseList(payload);
    }, [org_id, org_check_required, getWarehouseList]);

    useEffect(() => {
        return () => {
            dispatch({ type: CLEAR_INVENTORY_LOCATIONS_DROPDOWN_LIST_DATA, payload: InventoryLocationType.WAREHOUSE });
        }
    }, [dispatch]);

    useEffect(() => {
        if (prefillObj && !methods.getValues(name)) {
            methods.setValue(name, prefillObj);
        }
        if (prefill && prefill.length > 0 && memoizedRepairCenterDropdown && memoizedRepairCenterDropdown.length > 0) {
            const find = memoizedRepairCenterDropdown.find((option) => prefill.includes(option.id));
            if (find && !methods.getValues(name)) {
                methods.setValue(name, find);
            }
        }
    }, [prefillObj, prefill, memoizedRepairCenterDropdown, name, methods]);

    return (
        <Select
            className={className}
            label={label}
            name={name}
            options={memoizedRepairCenterDropdown}
            isLoading={isRepairCenterDropdownLoading}
            onInputChange={(event) => {
                if (event.length > 0) {
                    let p = { query: event };
                    if (org_check_required) p.org_id = org_id;
                    debouncedWarehouseSearchSearch(p)
                }
            }}
            onChange={(event) => {
                const value = event?.value;
                onChange(value)
            }}
            readOnly={readOnly}
            required={required}
        />
    )
}